import React, {useState, useRef, useEffect} from 'react';
import ReactDOM from "react-dom";
import axios from "axios";
import {toast} from "react-toastify";
import _ from "lodash";
import CreateEditJob from "../../components/job/CreateEditJob";

const JOB_DEFAULTS = {
    customer_id:    "",
    site_id:        "",
    name:           "",
    job_type_id:    "",
    notes:          "",
    attachments:    []
}

const CreateEditJobPage = (props) => {
    const {
        siteId      = null,
        customerId  = null,
        jobId       = null,
        origin      = 'index'
    } = props;

    const handleCancel = () => {
        if (origin === "customer" && !!customerId) {
            window.location.replace(route('customer.show', {
                customer:   customerId,
                tab:        "jobs"
            }).toString());
        } else if (origin === "overview-survey") {
            window.location.replace(route('overview.survey.index').toString());
        } else if (origin === "overview-quote") {
            window.location.replace(route('overview.quote.index').toString());
        } else if (origin === "overview-order") {
            window.location.replace(route('overview.order.index').toString());
        } else if (origin === "overview-delivery") {
            window.location.replace(route('overview.delivery.index').toString());
        } else if (origin === "overview-installation") {
            window.location.replace(route('overview.installation.index').toString());
        } else if (origin === "dashboard") {
            window.location.replace(route('dashboard').toString());
        } else if (!!jobId) {
            window.location.replace(route('job.show', {
                job: jobId,
            }).toString());
        } else {
            window.location.replace(route('job.index', {
                job: jobId,
            }).toString());
        }
    }

    const handleComplete = (job) => {
        window.location.replace(route('job.show', {
            job:   job,
        }).toString());
    }

    const handleDelete = () => {
        window.location.replace(route('job.index').toString());
    }

    return (
        <div className="m-0 mb-4 p-0">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <h1 className="h4 m-0 text-eh-navy">{!!jobId ? "Edit Job" : "Create Job"}</h1>
            </div>
            <CreateEditJob
                siteId={siteId}
                customerId={customerId}
                jobId={jobId}
                onCancel={() => handleCancel()}
                onComplete={(job) => handleComplete(job)}
                onDelete={() => handleDelete()}
                parentId={"create-edit-job-page"}
            />
        </div>
    )
}

export default CreateEditJobPage;

const target = document.getElementById('create-edit-job-page');
if (target) {
    let {
        siteId      = null,
        customerId  = null,
        jobId       = null,
        origin      = 'index'
    } = target.dataset;

    siteId      = !!siteId && siteId !== "" ? siteId : null;
    customerId  = !!customerId && customerId !== "" ? customerId : null;
    jobId       = !!jobId && jobId !== "" ? jobId : null;

    ReactDOM.render(
        <CreateEditJobPage
            siteId={siteId}
            customerId={customerId}
            jobId={jobId}
            origin={origin}
        />
        , target);
}
